// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"VideoPreview-module__wrapper___3jDno","video":"VideoPreview-module__video___18434","placeholder":"VideoPreview-module__placeholder___1-nhp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/VideoPreview/VideoPreview.module.sass
// module id = 1032
// module chunks = 0